import React, { useState, useEffect } from "react";
import {
  Col,
  Form,
  Row,
  Table,
  Image,
  // Modal,
  Container,
  Button,
} from "react-bootstrap";
import moment from "moment";
import { NavLink } from "react-router-dom";
import LeftSideNavigation from "../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../navigationSection/RightSideNavigation";
import { TopNavigationBarMobile } from "../navigationSection/TopNavigationBarMobile";
import { Menu, MenuItem } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";

import { FormControl, InputLabel, Select, TextField } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import BasicPagination from "../../Pagination/Pagination";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../store/actions/errorActions";
import { settlementSummary } from "../../../store/actions/VendorReports/vendorReportsRestaurant";
import SelectFilter from "../../reusableComponents/selectFilter";
import isEmpty from "../../../store/validation/is-Empty";
import CSVDownloader from "../../reusableComponents/csvDownload/csvDownload";
import { SETTLEMENT_TYPE } from "../../../enums/GlobalEnums";

const roles = [0, 1];

const MainSettlementsVendor = (props) => {
  const [showFilter, setshowFilter] = useState(false);
  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const [dateQuery, setDateQuery] = useState({
    // startDate: moment().format("YYYY-MM-DD"),
    // endDate: moment().format("YYYY-MM-DD"),
  });
  const [state, setState] = useState({
    search: "",
  });

  const [anchorEl, setAnchorEl] = React.useState(null);

  const [sort, setSort] = useState("");

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };

  const onSearchChange = (e) => {

    setState({
      ...state,
      [e.target.name]: e.target.value,
    });

  };

  const onDateChangeHandler = () => (data, type) => {
    setDateQuery(data);

  }

  const getData = () => {
    props.settlementSummary(props.auth.user.accessToken, dateQuery, 1);

  }

  useEffect((async) => {
    const DateForm = {
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    }
    if (!isEmpty(dateQuery)) {
      getData(props.auth.user.accessToken, dateQuery.startDate === 'undefined' ? DateForm : dateQuery);
    }

  }, [dateQuery]);


  const userFilter = [
    { title: "Total Amount", disabled: true },
    { title: `Low to High 🠑`, disabled: false },
    { title: "High to Low 🠓", disabled: false },
  ];
  const [filter, setFilter] = useState({});
  let tempdata = props?.settlemetData;
  if (state.search) {
    tempdata = props?.settlemetData && props?.settlemetData.filter((data) => {
      return (
        data?.id?.toString().includes(state.search) ||
        data?.transaction_number?.toString().includes(state.search)
      )
    });
  }
  if (sort === "Low to High 🠑") {
    tempdata = tempdata.sort(
      (a, b) =>
        Number.parseFloat(
          a.scanAndPayPayAmount +
          a?.eventPayAmount +
          a?.orderPayAmount +
          a?.orderTipAmount
        ).toFixed(2) -
        Number.parseFloat(
          b?.scanAndPayPayAmount +
          b?.eventPayAmount +
          b?.orderPayAmount +
          b?.orderTipAmount
        ).toFixed(2)
    );
  } else if (sort === "High to Low 🠓") {
    tempdata = tempdata.sort(
      (a, b) =>
        Number.parseFloat(
          b?.total_amount
        ).toFixed(2) -
        Number.parseFloat(
          a?.total_amount
        ).toFixed(2)
    );
  }

  if (filter.payout_type) {
    tempdata = tempdata.filter(i => i.payout_type == filter.payout_type)
  }

  const downloadData = {
    headers: [
      { label: "Transaction ID", key: "id" },
      { label: "Settlement Date & Time", key: "datetime" },
      { label: "Settlement Type", key: "Stype" },
      { label: "Settled Amount", key: "amount" },
      { label: "status", key: "status" },
    ],
    data: tempdata
      ? tempdata?.map((ele) => {
        return {
          id: ele?.id || ele?.transaction_number || ele?._id,
          datetime: `${moment(ele?.createdAt).format("Do MMM YYYY hh:mm A")}`,
          Stype: `${ele?.payout_type === 0 ? "order" : ele?.payout_type === 1 ? "Tip" : ele?.payout_type === 2 ? " Events" : "Scan And Pay"}`,
          amount: ele?.total_amount.toFixed(2),
          status: `${ele?.settle_payment_status === 0 ? "pending" : ele?.settle_payment_status === 1 ? "completed" : ele?.settle_payment_status === 2 ? "Cancelled" : "Failure"}`,
        };
      })
      : [],
  };



  const [showSearch, setShowSearch] = useState(false);

  return (
    <React.Fragment>
      <div className="container-fluid superadmin-orderscomponent-main super-admin-vendor-private-orders">
        <Row>
          <div className="left-side-panel">
            <LeftSideNavigation />
          </div>
          <div className="top-panel">
            <TopNavigationBarMobile displayLeft="logo" />
          </div>
          <div className="right-side-panel">
            <RightSideNavigation />
            <Container fluid>
              <div className="super-admin-inside-right-side-panel">
                {/* <div className="d-flex justify-content-between align-items-center pt-4 pb-4 ">
                  <div className="f24_700_HelveticaNeue">
                    Settlement Reports
                  </div>
                </div> */}
                <div className="d-flex justify-content-between align-items-center">
                  <div className="super_admin_add_vendor mb-4">
                    <h5 className="main_header_text">
                      Settlement Reports
                    </h5>
                  </div>
                  <div className="text-right" align="right">
                    <div className="f12-400">Report Run Date: {moment().format("Do MMM, YYYY")}</div>
                    <div className="d-flex mt-2">
                      <div className="f12-400">Report Range Date :</div>
                      <div className="f12-700 ml-2">
                        {moment(dateQuery?.startDate).format("ll")} -{" "}
                        {moment(dateQuery?.endDate).format("ll")}
                      </div>
                    </div>
                  </div>
                </div>
                <Row className="align-items-center">
                  <Col className="col-auto seating-topbar-search" xs={4} md={1}>
                    <div className="d-flex align-items-center justify-content-between">
                      <Image
                        onClick={() =>
                          // this.setState({ showSearch: !this.state.showSearch })
                          setShowSearch(!showSearch)
                        }
                        alt="Search"
                        title="Search"
                        width="80px"
                        src={require("../../../assets/images/iconButton/newsearchicon.svg")}
                      />
                      <Image
                        onClick={handleClick}
                        aria-controls="simple-menu"
                        aria-haspopup="true"
                        src={require("../../../assets/images/iconButton/sortbtn.svg")}
                        width="80px"
                      />
                      <Menu
                        id="simple-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                      >
                        {userFilter.map((ele, index) => {
                          return (
                            <MenuItem
                              value={ele.title}
                              key={index}
                              onClick={() => setSort(ele.title)}
                              disabled={ele.disabled}
                            >
                              {ele.title}
                            </MenuItem>
                          );
                        })}
                      </Menu>
                      <Image
                        src={require("../../../assets/images/iconButton/filterbtn.svg")}
                        width="80px"
                        alt="Filter Icon"
                        onClick={() => {
                          setshowFilter(!showFilter);
                        }}
                      />
                      <CSVDownloader
                        filename={"settlement"}
                        headers={downloadData.headers}
                        data={downloadData.data}
                      />
                    </div>
                    {/* 
                    <div className="filter-button">
                      <div
                        onClick={() => {
                          setshowFilter(!showFilter);
                        }}
                        className="d-flex align-items-center justify-content-between cursor"
                      >
                        <Image
                          alt="filter"
                          title="filter"
                          width="20px"
                          src={require("../../../assets/images/ActionImages/image/filter.svg")}
                        />
                        <div className="f12-500 text-blue mx-2">Filter</div>
                        <i
                          className="fa fa-angle-down text-blue"
                          aria-hidden="true"
                        ></i>
                      </div>
                    </div> */}
                  </Col>
                  <Col xs={4} md={4}>

                  </Col>
                  <Col md={3}></Col>
                  <Col md={4} xs={4} className="d-flex justify-content-end">
                    <div className="f14-500 mb-2">
                      <SelectFilter onDateChange={onDateChangeHandler()} />
                    </div>
                  </Col>
                </Row>
                {showFilter && (
                  <div
                    className="container-fluid"
                    style={{ backgroundColor: "#ffffff" }}
                  >
                    <div className=" p-4">
                      <Row>
                        {/* <Col md={6}>
                          Date Range
                          <div
                            className="d-flex justify-content-start"
                            style={{ alignItems: "center" }}
                          >
                            <TextField
                              type="date"
                              variant="outlined"
                              onChange={props.onStartDateChange}
                              value={props.startDate}
                            />
                            &nbsp;To&nbsp;
                            <TextField
                              type="date"
                              variant="outlined"
                              onChange={props.onEndDateChange}
                              value={props.endDate}
                            />
                          </div> 
                          <br />
                        </Col> */}
                        <Col md={6}>
                          <div className="f12-500">Settlement Type</div>
                          <Form.Group>
                            <FormControl variant="outlined" className="w-100">
                              <InputLabel htmlFor="outlined-Status">
                                Settlement Type
                              </InputLabel>
                              <Select
                                value={filter.payout_type || ""}
                                onChange={(e) => setFilter({ ...filter, payout_type: e.target.value })}
                                label="Settlement Type"
                                inputProps={{
                                  name: "Settlement Type",
                                  id: "outlined-Status",
                                }}
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                {SETTLEMENT_TYPE.map((e) => {
                                  return <option value={e.value}>{e.title}</option>
                                })}

                              </Select>
                            </FormControl>
                          </Form.Group>
                        </Col>
                        {/* <Col md={6}>
                          <div className="f12-500">Status</div>
                          <Form.Group>
                            <FormControl variant="outlined" className="w-100">
                              <InputLabel htmlFor="outlined-Status">
                                Status
                              </InputLabel>
                              <Select
                                value={""}
                                onChange={() => { }}
                                label="Status"
                                inputProps={{
                                  name: "Status",
                                  id: "outlined-Status",
                                }}
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                <option value={""}>Menu</option>
                              </Select>
                            </FormControl>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <div className="f12-500">Order Type</div>
                          <Form.Group>
                            <FormControl variant="outlined" className="w-100">
                              <InputLabel htmlFor="outlined-Status">
                                Order Type
                              </InputLabel>
                              <Select
                                value={""}
                                onChange={() => { }}
                                label="Order Type"
                                inputProps={{
                                  name: "Order Type",
                                  id: "outlined-Status",
                                }}
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                <option value={""}>Menu</option>
                              </Select>
                            </FormControl>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <div className="f12-500">Select Payment Method</div>
                          <Form.Group>
                            <FormControl variant="outlined" className="w-100">
                              <InputLabel htmlFor="outlined-Status">
                                Select Payment Method
                              </InputLabel>
                              <Select
                                value={""}
                                onChange={() => { }}
                                label="Select Payment Method"
                                inputProps={{
                                  name: "Select Payment Method",
                                  id: "outlined-Status",
                                }}
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                <option value={""}>Menu</option>
                              </Select>
                            </FormControl>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <div className="f12-500">Transaction Type</div>
                          <Form.Group>
                            <FormControl variant="outlined" className="w-100">
                              <InputLabel htmlFor="outlined-Status">
                                Transaction Type
                              </InputLabel>
                              <Select
                                value={""}
                                onChange={() => { }}
                                label="Transaction Type"
                                inputProps={{
                                  name: "Transaction Type",
                                  id: "outlined-Status",
                                }}
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                <option value={""}>Menu</option>
                              </Select>
                            </FormControl>
                          </Form.Group>
                        </Col> */}
                      </Row>
                      <div class="mt-5 d-flex">
                        <button
                          type="button"
                          class="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                          title="Cancel Button"
                          onClick={() => setFilter({})}
                        >
                          Reset
                        </button>
                        <button
                          type="button"
                          class="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                          title="Confirm Button"
                          onClick={() => setshowFilter(false)}
                        >
                          Search
                        </button>
                      </div>
                    </div>
                  </div>
                )}
                {showSearch && (
                  <>
                    <div className="filter-button-search">
                      <Paper component="form" className="enSearch2 d-flex">
                        <IconButton type="submit" aria-label="search">
                          <SearchIcon />
                        </IconButton>
                        <InputBase
                          placeholder="Search"
                          name="search"
                          inputProps={{
                            "aria-label": "Search by Name or Phone Number",
                          }}
                          onChange={onSearchChange}
                          value={state.search}
                        />
                      </Paper>
                    </div>
                  </>
                )

                }

                <div className="col-12 p-0 user-table-reusable-superadmin table-responsive">
                  <Table className="HideShowTable enMinWidth900">
                    <thead style={{ fontSize: "10px" }}>
                      <tr className="super_admin_all_users_table_head">
                        <th style={{ width: "20%" }} className="f12-700">
                          Transaction ID
                        </th>
                        <th style={{ width: "20%" }} className="f12-700">
                          Settlement Date<br />& Time
                        </th>
                        <th style={{ width: "20%" }} className="f12-700">
                          Settlement Type
                        </th>
                        <th style={{ width: "20%" }} className="f12-700">
                          Settled Amount
                        </th>
                        <th style={{ width: "20%" }} className="f12-700">
                          Remittance Status
                        </th>
                        <th style={{ width: "20%" }} className="f12-700">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    {tempdata?.slice(start, end).map((data, index) => {
                      return (
                        <tbody>
                          <tr className="super_admin_all_users_table_body" key={index}>
                            <td style={{ width: "20%" }} className="f9-400">
                              {data?.id || data?.transaction_number || data?._id}
                            </td>
                            <td style={{ width: "20%" }} className="f9-400">
                              <div className="f12-400">{moment(data?.createdAt).format("Do MMM YYYY")}</div>
                              <div className="f12-400">{moment(data?.createdAt).format("hh:mm A")}</div>
                            </td>
                            {/* <td style={{width:'20%'}} className="f12-500">
                          {data?.payout_type}
                        </td> */}
                            <td style={{ width: '20%' }} className="f12-500">
                              {`${data?.payout_type}` === '0' ? <div>Order</div> : null ||
                                `${data?.payout_type}` === '1' ? <div>Tip</div> : null ||
                                  `${data?.payout_type}` === '2' ? <div>Events</div> : null ||
                                    `${data?.payout_type}` === '3' ? <div>Scan and Pay</div> : null ||
                                      `${data?.payout_type}` === '4' ? <div>Experience</div> : null}
                            </td>
                            <td style={{ width: "20%" }} className="f12-500">
                              ₹ {data?.total_amount.toFixed(2) || 0}
                            </td>
                            {`${data?.settle_payment_status}` === '0' ?
                              <td style={{ width: "20%" }} className="f12-500">
                                <div
                                  className="badge badge-warning p-2"
                                  style={{ borderRadius: "1rem", color: "white" }}
                                >
                                  Pending
                                </div>
                              </td>
                              : null ||
                                `${data?.settle_payment_status}` === '1' ?
                                <td style={{ width: "20%" }} className="f12-500">
                                  <div
                                    className="badge badge-success p-2"
                                    style={{ borderRadius: "1rem", color: "white" }}
                                  >
                                    Settled
                                  </div>
                                </td>
                                : null ||
                                  `${data?.settle_payment_status}` === '2' ?
                                  <td style={{ width: "20%" }} className="f12-500">
                                    <div
                                      className="badge badge-danger p-2"
                                      style={{ borderRadius: "1rem", color: "white" }}
                                    >
                                      Cancelled
                                    </div>
                                  </td>
                                  : null ||
                                    `${data?.settle_payment_status}` === '3' ?
                                    <td style={{ width: "20%" }} className="f12-500">
                                      <div
                                        className="badge badge-info p-2"
                                        style={{ borderRadius: "1rem", color: "white" }}
                                      >
                                        Failure
                                      </div>
                                    </td>
                                    : null}
                            {`${data?.settle_payment_status}` === '4' ?
                              <td style={{ width: "20%" }} className="f12-500">
                                <div
                                  className="badge badge-secondary p-2"
                                  style={{ borderRadius: "1rem", color: "white" }}
                                >
                                  Reversed
                                </div>
                              </td>
                              : null}

                            <td style={{ width: "20%" }} className="f12-500">
                              {`${data?.payout_type}` === '0' ?
                                <NavLink
                                  variant="link"
                                  className="enIconBtn mr-3"
                                  to={`/settlementsvendor/${data?.payout_type}/${data?._id}/${data?.restaurant_id}`}
                                >
                                  <Image
                                    src={require("../../../assets/images/UserManagement/eye.svg")}
                                    alt="View"
                                    title="View"
                                    fluid
                                  />
                                </NavLink>
                                : null ||
                                  `${data?.payout_type}` === '1' ?
                                  <NavLink
                                    variant="link"
                                    className="enIconBtn mr-3"
                                    to={`/settlementsvendor/${data?.payout_type}/${data?._id}/${data?.restaurant_id}`}
                                  >
                                    <Image
                                      src={require("../../../assets/images/UserManagement/eye.svg")}
                                      alt="View"
                                      title="View"
                                      fluid
                                    />
                                  </NavLink>
                                  : null ||
                                    `${data?.payout_type}` === '2' ?
                                    <NavLink
                                      variant="link"
                                      className="enIconBtn mr-3"
                                      to={`/settlementeventsvendor/${data?.payout_type}/${data?._id}/${data?.restaurant_id}`}
                                    >
                                      <Image
                                        src={require("../../../assets/images/UserManagement/eye.svg")}
                                        alt="View"
                                        title="View"
                                        fluid
                                      />
                                    </NavLink>
                                    : null ||
                                      `${data?.payout_type}` === '3' ?
                                      <NavLink
                                        variant="link"
                                        className="enIconBtn mr-3"
                                        to={`/settlementscanandpayvendor/${data?.payout_type}/${data?._id}/${data?.restaurant_id}`}
                                      >
                                        <Image
                                          src={require("../../../assets/images/UserManagement/eye.svg")}
                                          alt="View"
                                          title="View"
                                          fluid
                                        />
                                      </NavLink>
                                      : null ||
                                        `${data?.payout_type}` === '4' ?
                                        <NavLink
                                          variant="link"
                                          className="enIconBtn mr-3"
                                          to={`/settlementexpvendor/${data?.payout_type}/${data?._id}/${data?.restaurant_id}`}
                                        >
                                          <Image
                                            src={require("../../../assets/images/UserManagement/eye.svg")}
                                            alt="View"
                                            title="View"
                                            fluid
                                          />
                                        </NavLink>
                                        : null}
                            </td>
                          </tr>

                        </tbody>
                      )
                    })}
                    {/* <tbody>
                      <tr className="super_admin_all_users_table_body">
                        <td style={{ width: "20%" }} className="f12-500">
                          13434434343
                        </td>
                        <td style={{ width: "20%" }} className="f12-500">
                          16th Aug, 2020 09:15 PM
                        </td>
                        <td style={{ width: "20%" }} className="f12-500">
                          Order
                        </td>
                        <td style={{ width: "20%" }} className="f12-500">
                          ₹ 75000
                        </td>
                        <td style={{ width: "20%" }} className="f12-500">
                          <div
                            className="badge badge-success p-2"
                            style={{ borderRadius: "1rem", color: "white" }}
                          >
                            Paid
                          </div>
                        </td>
                        <td style={{ width: "20%" }} className="f12-500">
                          <NavLink
                            variant="link"
                            className="enIconBtn mr-3"
                            to={`/settlementsvendor`}
                          >
                            <Image
                              src={require("../../../assets/images/UserManagement/eye.svg")}
                              alt="View"
                              title="View"
                              fluid
                            />
                          </NavLink>
                        </td>
                      </tr>
                      <br />
                      <tr className="super_admin_all_users_table_body">
                        <td style={{ width: "20%" }} className="f12-500">
                          13434434343
                        </td>
                        <td style={{ width: "20%" }} className="f12-500">
                          16th Aug, 2020 09:15 PM
                        </td>
                        <td style={{ width: "20%" }} className="f12-500">
                          Events
                        </td>
                        <td style={{ width: "20%" }} className="f12-500">
                          ₹ 75000
                        </td>
                        <td style={{ width: "20%" }} className="f12-500">
                          <div
                            className="badge badge-success p-2"
                            style={{ borderRadius: "1rem", color: "white" }}
                          >
                            Paid
                          </div>
                        </td>
                        <td style={{ width: "20%" }} className="f12-500">
                          <NavLink
                            variant="link"
                            className="enIconBtn mr-3"
                            to={`/settlementeventsvendor`}
                          >
                            <Image
                              src={require("../../../assets/images/UserManagement/eye.svg")}
                              alt="View"
                              title="View"
                              fluid
                            />
                          </NavLink>
                        </td>
                      </tr>
                      <br />
                      <tr className="super_admin_all_users_table_body">
                        <td style={{ width: "20%" }} className="f12-500">
                          13434434343
                        </td>
                        <td style={{ width: "20%" }} className="f12-500">
                          16th Aug, 2020 09:15 PM
                        </td>
                        <td style={{ width: "20%" }} className="f12-500">
                          Scan & Pay
                        </td>
                        <td style={{ width: "20%" }} className="f12-500">
                          ₹ 75000
                        </td>
                        <td style={{ width: "20%" }} className="f12-500">
                          <div
                            className="badge badge-success p-2"
                            style={{ borderRadius: "1rem", color: "white" }}
                          >
                            Paid
                          </div>
                        </td>
                        <td style={{ width: "20%" }} className="f12-500">
                          <NavLink
                            variant="link"
                            className="enIconBtn mr-3"
                            to={`/settlementscanandpayvendor`}
                          >
                            <Image
                              src={require("../../../assets/images/UserManagement/eye.svg")}
                              alt="View"
                              title="View"
                              fluid
                            />
                          </NavLink>
                        </td>
                      </tr>
                      <br />
                    </tbody> */}
                  </Table>
                </div>
                <div className="p4v2-menu-pagination">
                  <BasicPagination
                    totalRecords={props?.settlemetData?.length}
                    limit={10}
                    batch={page}
                    onBatchChange={(e) => handleBatchChange(e)}
                  />
                </div>
              </div>
            </Container>
          </div>
          <div className="bottom-panel"></div>
        </Row>
      </div>
    </React.Fragment>
  );
};

// const Filter = (props) => {
//   const [open, setOpen] = useState(false);
//   const [state, setState] = useState(0);
//   const onOpenModal = () => setOpen(true);
//   const onCloseModel = () => setOpen(false);
//   return (
//     <>
//       <div
//         onClick={onOpenModal}
//         className="d-flex align-items-center justify-content-between cursor"
//       >
//         <Image
//           alt="filter"
//           title="filter"
//           width="20px"
//           src={require("../../../assets/images/ActionImages/image/filter.svg")}
//         />
//         <div className="f12-500 text-blue mx-2">Filter</div>
//         <i className="fa fa-angle-down text-blue" aria-hidden="true"></i>
//       </div>
//       {/* <Modal show={open} onHide={onCloseModel} centered>
//           <Modal.Header className="py-0 pt-2 border-0" closeButton>
//             <Modal.Title>Filter</Modal.Title>
//           </Modal.Header>
//           <Modal.Body className="f16-500">
//             Select one relevant option from below
//             <div className="row mt-4">
//               <div className="col-6 col-md-4 mb-4">
//                 <div
//                   className={`status-selected-button-box f16-500 ${
//                     state === 0 && `sts_sld_btn_box_a`
//                   }`}
//                   type="button"
//                   onClick={() => {
//                     setState(0);
//                   }}
//                 >
//                   <div class="row justify-content-center">
//                     <div class="">All</div>
//                   </div>
//                 </div>
//               </div>
//               <div class="col-6 col-md-4 mb-4">
//                 <div
//                   className={`status-selected-button-box f16-500 ${
//                     state === 1 && `sts_sld_btn_box_a`
//                   }`}
//                   type="button"
//                   onClick={() => {
//                     setState(1);
//                   }}
//                 >
//                   <div class="row justify-content-center">
//                     <div class="">Active</div>
//                   </div>
//                 </div>
//               </div>
//               <div class="col-6 col-md-4 mb-4">
//                 <div
//                   className={`status-selected-button-box f16-500 ${
//                     state === 2 && `sts_sld_btn_box_a`
//                   }`}
//                   type="button"
//                   onClick={() => {
//                     setState(2);
//                   }}
//                 >
//                   <div class="row justify-content-center">
//                     <div class="">Inactive</div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </Modal.Body>
//           <Modal.Footer className="justify-content-start border-0">
//             <Button
//               variant="outline-secondary"
//               className="btn-md mr-4 px-5"
//               onClick={() => {
//                 setState(0);
//                 props.filterData(1, onCloseModel);
//               }}
//             >
//               Reset Filter
//             </Button>
//             <Button
//               variant="danger"
//               className="btn-md px-5"
//               onClick={() => {
//                 props.filterData(state, onCloseModel);
//               }}
//             >
//               Apply Filter
//             </Button>
//           </Modal.Footer>
//         </Modal> */}
//     </>
//   );
// };

MainSettlementsVendor.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  settlemetData: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => ({
  settlemetData: state.reports.settlemetReport.data,
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  settlementSummary,
})(MainSettlementsVendor);
